import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { UserProfile } from '../user/UserProfile'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ChatSenderInput')
export class ChatSender {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('csnd') })
  _id?: string

  @Field(() => UserProfile)
  @Prop({ type: UserProfile })
  profile: UserProfile

  // Denormalized company name of the sender's linked customer, captured when the conversation is built so the
  // inbox row shows it without an N+1 lookup. Blank on legacy chats / customers without a company.
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  company?: string

  // The phone the sender typed in the storefront widget, in international format; absent on a
  // conversation that arrived by email.
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  phone?: string
}
